import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import ChatWidget from "./components/layout/ChatWidget";
import VoiceWidget from "./components/layout/VoiceWidget";
import Home from "./pages/Home";
import Services from "./pages/Services";
import ServicePage from "./pages/ServicePage";
import Locations from "./pages/LocationsNew";
import CityPage from "./pages/CityPage";
import Quote from "./pages/Quote";
import QuoteSuccess from "./pages/QuoteSuccess";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Pricing from "./pages/Pricing";
import Admin from "./pages/Admin";
import Projects from "./pages/Projects";
import Payments from "./pages/Payments";
import ServiceAreas from "./pages/ServiceAreas";
import DynamicSeoPage from "./pages/DynamicSeoPage";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import { Toaster } from "./components/ui/sonner";
import "./App.css";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen bg-background">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServicePage />} />
              <Route path="/locations" element={<Locations />} />
              <Route path="/locations/:slug" element={<CityPage />} />
              <Route path="/quote" element={<Quote />} />
              <Route path="/quote/success" element={<QuoteSuccess />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/payments" element={<Payments />} />
              <Route path="/service-areas" element={<ServiceAreas />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              
              {/* SEO Pages - Dynamic routes with slug parameter */}
              <Route path="/:slug" element={<DynamicSeoPage />} />
            </Routes>
          </main>
          <Footer />
          <ChatWidget />
          <VoiceWidget />
          <Toaster position="top-right" />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
